// extracted by mini-css-extract-plugin
export default {"product-report-container":"doctor_product-report-container__ueOLb"};